<!-- <section class="gap cart">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="cart-box">
          <ul class="cart-table head">
            <li>
              <div class="c-c">
                <div class="c-schedule">
                  <span>Lunes</span>
                </div>
                <div class="c-price">
                  <span>Martes</span>
                </div>
                <div class="c-quality">
                  <span>Miercoles</span>
                </div>
                <div class="c-total">
                  <span>Jueves</span>
                </div>
              </div>
            </li>
          </ul>
          <ul class="cart-table">
            <li>
              <div class="c-c">
                <div class="c-schedule">
                  <span class="orgnl">$ 40.00</span>
                  <del class="sale">$ 50.00</del>
                </div>
                <div class="c-price">
                  <span class="orgnl">$ 40.00</span>
                  <del class="sale">$ 50.00</del>
                </div>
                <div class="c-quality">
                  <span>TKD</span>
                </div>
                <div class="c-total">
                  <span>TKD</span>
                </div>
              </div>
            </li>
            <li>
              <div class="c-c">
                <div class="c-schedule">
                  <span class="orgnl">$ 40.00</span>
                  <del class="sale">$ 50.00</del>
                </div>
                <div class="c-price">
                  <span class="orgnl">$ 40.00</span>
                  <del class="sale">$ 50.00</del>
                </div>
                <div class="c-quality">
                  <span>TKD</span>
                </div>
                <div class="c-total">
                  <span>TKD</span>
                </div>
              </div>
            </li>
            <li>
              <div class="c-c">
                <div class="c-schedule">
                  <span class="orgnl">$ 40.00</span>
                  <del class="sale">$ 50.00</del>
                </div>
                <div class="c-price">
                  <span class="orgnl">$ 40.00</span>
                  <del class="sale">$ 50.00</del>
                </div>
                <div class="c-quality">
                  <span>TKD</span>
                </div>
                <div class="c-total">
                  <span>TKD</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section> -->

<section class="gap shop-style-one timetable-section cart"
         *ngIf="scheduleData">
  <!-- Encabezado principal -->
  <div class="heading">
    <figure>
      <img src="assets/images/heading-icon.png"
           alt="heading-icon-2">
    </figure>
    <span>{{ scheduleData.subTitle }}</span>
    <h2>{{ scheduleData.title }}</h2>
    <br /><br />
    <!-- Frase motivadora -->
    <p class="motivational-phrase">{{ scheduleData.motivationalPhrase }}</p>
    <!-- Texto marketero -->
    <p class="marketing-text">{{ scheduleData.marketingText }}</p>
  </div>

  <div class="container">
    <div class="inner-container">

      <!-- Tabs de SUCURSALES -->
      <div class="timetable-tabs tabs-box"
           style="padding-left:0">
        <ul class="tab-btns tab-buttons clearfix"
            style="justify-content: flex-start;">
          <li *ngFor="let branch of scheduleData.branches; let i = index"
              [class.active-btn]="activeBranchIndex === i"
              class="tab-btn"
              (click)="activarSucursal(i)">
            {{ branch.branchName }}
          </li>
        </ul>

        <!-- Contenido de cada sucursal -->
        <div class="tabs-content">

          <!-- Recorremos cada sucursal -->
          <div *ngFor="let branch of scheduleData.branches; let i = index"
               class="tab"
               [ngStyle]="{ 'display': activeBranchIndex === i ? 'block' : 'none' }">

            <!-- Título/encabezado de la sucursal -->
            <div class="table-title-box clearfix">
              <div class="data">
                <span>{{ scheduleData.subTitle }}</span>
                <h2>{{ branch.branchName }}</h2>
              </div>
            </div>

            <!-- Sub-tabs de CATEGORÍAS (Muay Thai, MMA, etc.) -->
            <div class="timetable-tabs tabs-box"
                 style="padding-left: 0;">
              <ul class="tab-btns tab-buttons clearfix">
                <li *ngFor="let cat of branch.categories; let j = index"
                    [class.active-btn]="cat.active"
                    class="tab-btn"
                    (click)="activarCategoria(branch, j)">
                  {{ cat.label }}
                </li>
              </ul>

              <div class="tabs-content">
                <!-- Por cada categoría, pintamos la tabla si está activa -->
                <div *ngFor="let cat of branch.categories; let j = index"
                     class="tab"
                     [ngStyle]="{ 'display': cat.active ? 'block' : 'none' }">
                  <!-- Estructura tipo "tabla": la 1ra col es la franja horaria, las cols siguientes son días -->

                  <div class="container">
                    <div class="row">
                      <div class="col-lg-12">

                        <div class="cart-box">
                          <!-- Tabla de Horarios -->
                          <ul class="cart-table head">
                            <li>
                              <div class="c-c">
                                <!-- Columna "HORARIO" -->
                                <div class="c-schedule">
                                  <span>HORARIO</span>
                                </div>
                                <!-- Columnas para cada día de la semana -->
                                <div class="c-price"
                                     *ngFor="let d of branch.days">
                                  <span>{{ d }}</span>
                                </div>
                              </div>
                            </li>
                          </ul>

                          <ul class="cart-table">
                            <li *ngFor="let range of getUniqueTimeRanges(cat); let r = index">
                              <div class="c-c">
                                <!-- Columna HORARIO -->
                                <div class="c-schedule">
                                  <span class="orgnl">{{ range }}</span>
                                </div>

                                <!-- Columnas por cada día -->
                                <div class="c-price"
                                     *ngFor="let day of branch.days">
                                  <span class="orgnl">
                                    <ng-container *ngIf="getTimeBoxForDayAndRange(cat, day, range) as found">
                                      {{ found.nombre }}
                                      <span *ngIf="found.instructor">
                                        <br />{{ found.instructor }}
                                      </span>
                                    </ng-container>
                                    <ng-container *ngIf="!getTimeBoxForDayAndRange(cat, day, range)">
                                      -
                                    </ng-container>
                                  </span>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- Fin de cada categoría -->
              </div>
              <!-- Fin .tabs-content categorías -->
            </div>
            <!-- Fin sub-tabs de categorías -->
          </div>
          <!-- Fin de cada sucursal -->
        </div>
        <!-- Fin .tabs-content sucursales -->
      </div>
      <!-- Fin timetable-tabs (sucursales) -->

    </div>
  </div>
</section>
